import { xMean } from "./xMean.js";
import { xRolling } from "./xRolling.js";
/**
 * This function calculates a rolling average
 * @param array - array
 * @param options - option
 */
export function xRollingAverage(array, options = {}) {
    return xRolling(array, xMean, options);
}
//# sourceMappingURL=xRollingAverage.js.map